const cstSupMenuItems = {
  items: [
    {
      id: 'admin-panel',
      title: 'CST SUPERVISOR LOGIN',
      type: 'group',
      icon: 'icon-monitor',
      children: [
        {
          id: 'cst-sup-dashboard',
          title: 'CST Supervisor Dashboard',
          type: 'item',
          icon: 'feather icon-bar-chart',
          url: '/cst-supervisor-portal/cst-sup-dashboard'
        },
        {
          id: 'cst-sup-clientdetails',
          title: 'Clients',
          type: 'item',
          icon: 'feather icon-list',
          url: '/cst-supervisor-portal/cst-sup-clientdetails'
        },
        {
          id: 'cst-sup-userdetails',
          title: 'CST Users',
          type: 'item',
          icon: 'feather icon-users',
          url: '/cst-supervisor-portal/cst-sup-userdetails'
        },
        {
          id: 'cst-sup-reportdetails',
          title: 'Report Details',
          type: 'item',
          icon: 'feather icon-users',
          url: '/cst-portal/cst-reportdetails'
        },
        {
          id: 'cst-sup-employee-tracking',
          title: 'Employee Tracking',
          type: 'item',
          icon: 'feather icon-activity',
          url: '/cst-supervisor-portal/cst-sup-employee-tracking'
        },
        {
          id: 'cst-sup-single-pending',
          title: 'Single Component Pending',
          type: 'item',
          icon: 'feather icon-target',
          url: '/cst-supervisor-portal/single-component-pending'
        },
      ]
    }
  ]
};

export default cstSupMenuItems;
